import { reactLocalStorage } from "reactjs-localstorage";
// const BASE_URL = 'http://3.110.105.243:8157/api/v1/admin/';
// const BASE_URL = 'http://43.205.231.210:8157/api/v1/admin/';
// const BASE_URL = 'http://43.205.231.210:8167/api/v1/admin/';

// const BASE_URL = 'http://15.206.167.101:8167/api/v1/admin/'; //Production Backend

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.thewinners2.in/api/v1/admin/";

const ALLOW_ORIGIN = "15.206.167.101:8167";
const USER_TYPE = "Admin";

function get(endpoint, params) {
  return requestData(endpoint, params);
}

function post(endpoint, params) {
  return requestData(endpoint, params, "POST");
}

function put(endpoint, params) {
  return requestData(endpoint, params, "PUT");
}

function deletemethod(endpoint, params) {
  return requestData(endpoint, params, "DELETE");
}

async function requestData(url, data = {}, method = "GET") {
  const xhr = new XMLHttpRequest();
  xhr.open(method, BASE_URL + url);
  xhr.timeout = 45000;

  const isLoginRequest = url === "login";
  // Login must always be a clean request. Do not forward an expired or stale
  // admin token from a previous browser session.
  if (!isLoginRequest && checkingAuth()) {
    xhr.setRequestHeader("authorization", checkingAuth());
  }
  xhr.setRequestHeader("Content-Type", "application/json");
  if (!isLoginRequest) {
    xhr.setRequestHeader("userType", USER_TYPE);
  }

  return new Promise((resolve, reject) => {
    xhr.onload = () => {
      let response;
      try {
        response = xhr.responseText ? JSON.parse(xhr.responseText) : {};
      } catch (error) {
        reject(new Error("The server returned an invalid response."));
        return;
      }

      if ([200, 201, 400, 403, 406, 500].includes(xhr.status)) {
        resolve(response);
      } else {
        reject(response || new Error(`Request failed with status ${xhr.status}`));
      }
    };

    xhr.onerror = () => reject(new Error("Network request failed."));
    xhr.ontimeout = () => reject(new Error("The request took too long. Please try again."));

    if (method === "GET") {
      xhr.send();
    } else {
      xhr.send(JSON.stringify(data));
    }
  });
}

async function fileUplode(
  url,
  method,
  file,
  object_get = {},
  tokenCustom = null,
) {
  let token = "";
  let user = reactLocalStorage.get("token");

  if (user && user != null && Object.keys(user).length > 0) {
    token = user;
  }
  // let bash_url = "http://13.127.101.102:5011/api/v1/";
  let apiUrl = BASE_URL + url;

  if (token != "") {
    var toooo = token;
  }
  //  console.log("tokenn",toooo);
  let headers = {
    // 'Accept': 'application/json',
    // "Content-Type": "multipart/form-data",
    // "Access-Control-Allow-Origin": "http://13.127.101.102:5008",
    authorization: toooo,
    userType: "Admin",
    // 'Authorization': 'Bearer ' + login_status,
  };

  return await fetch(apiUrl, {
    method: method,
    body: file,
    redirect: "follow",
    headers: headers,
  })
    .then((response) => {
      console.log("responseee", response, headers);
      return response.json();
    })
    .then(
      (result) => {
        console.log("ResponIMG", result);
        return result;
      },
      (error) => {
        return error;
      },
    );
}

async function fileVideoUplode(
  url,
  method,
  file,
  object_get = {},
  tokenCustom = null,
) {
  let token = "";
  let user = reactLocalStorage.get("token");
  // console.log("UserTok", user);
  if (user && user != null && Object.keys(user).length > 0) {
    token = user;
  }
  // let bash_url = "http://13.127.101.102:5011/api/v1/";
  let apiUrl = BASE_URL + url;
  // let data = new FormData();
  // data.append("image", file);
  // Object.keys(object_get).forEach(function (key) {
  //   let ddd = object_get[key];
  //   data.append(key, ddd);
  // });

  if (token != "") {
    var toooo = token;
  }
  //  console.log("tokenn",toooo);
  let headers = {
    // 'Accept': 'application/json',
    // "Content-Type": "multipart/form-data",
    // "Access-Control-Allow-Origin": "http://13.127.101.102:5008",
    authorization: toooo,
    userType: "Admin",
    // 'Authorization': 'Bearer ' + login_status,
  };

  return await fetch(apiUrl, {
    method: method,
    body: file,
    redirect: "follow",
    headers: headers,
  })
    .then((response) => {
      // console.log("responseee", response, headers);
      return response.json();
    })
    .then(
      (result) => {
        console.log("ResponIMG", result);
        return result;
      },
      (error) => {
        return error;
      },
    );
}

//Upload CSV for Bulk upload
async function csvForBulkUplode(
  url,
  method,
  file,
  object_get = {},
  tokenCustom = null,
) {
  let token = "";
  let user = reactLocalStorage.get("token");

  if (user && user != null && Object.keys(user).length > 0) {
    token = user;
  }
  // let bash_url = "http://13.127.101.102:5011/api/v1/";
  let apiUrl = BASE_URL + url;

  if (token != "") {
    var toooo = token;
  }
  //  console.log("tokenn",toooo);
  let headers = {
    // 'Accept': 'application/json',
    // "Content-Type": "multipart/form-data",
    // "Access-Control-Allow-Origin": "http://13.127.101.102:5008",
    authorization: toooo,
    userType: "Admin",
    // 'Authorization': 'Bearer ' + login_status,
  };

  return await fetch(apiUrl, {
    method: method,
    body: file,
    redirect: "follow",
    headers: headers,
  })
    .then((response) => {
      console.log("responseee", response, headers);
      return response.json();
    })
    .then(
      (result) => {
        console.log("ResponIMG", result);
        return result;
      },
      (error) => {
        return error;
      },
    );
}

function checkingAuth() {
  // Some legacy screens use reactLocalStorage while authentication uses the
  // native browser API. Accept either value so every admin request has the
  // session token after login.
  return localStorage.getItem("token") || reactLocalStorage.get("token") || false;
}

export default {
  csvForBulkUplode,
  requestData,
  get,
  post,
  put,
  deletemethod,
  fileUplode,
  fileVideoUplode,
};
